const Loader = ({className}) => {
  return (
    <div className={`spinner-border ${className}`}>
      <span className="sr-only"></span>
    </div>
  );
};

export default Loader;
